/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
// @ts-ignore
import { ILocationDto } from "@/models/club";
import L from "leaflet";
import "leaflet-easybutton/src/easy-button.css";
import "leaflet-easybutton/src/easy-button.js";
import "leaflet/dist/leaflet.css";
import { useEffect, useState } from "react";
import { MapContainer, TileLayer, useMap } from "react-leaflet";
import useGetAddressByCoordination from "./hooks/useGetAddressByCoordination";
import Styled from "./style.module.scss";
import { OpenStreetMapProvider, GeoSearchControl } from "leaflet-geosearch";
import "leaflet-geosearch/dist/geosearch.css";

type Props = {
  setLocation: (e: ILocationDto) => void;
  latLng: ILocationDto;
  setAddress: (e: string) => void;
  center: ILocationDto | undefined;
};

type PhoneLocation = {
  latitude: number;
  longitude: number;
};

function MapAddress({ latLng, setLocation, setAddress, center }: Props) {
  const [map, setMap] = useState<L.Map | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Listen for getLocation event from WebView
    if (window.ReactNativeWebView)
      window.ReactNativeWebView.postMessage("getLocation");
  }, []);

  const handleLocation = (contactsData: unknown) => {
    const location = contactsData as PhoneLocation;
    setLocation({
      lat: location.latitude,
      lon: location.longitude,
    });
  };

  useEffect(() => {
    window.handleLocation = handleLocation;
  }, []);

  const { data } = useGetAddressByCoordination(
    latLng?.lat || 0,
    latLng?.lon || 0
  );

  useEffect(() => {
    if (data) {
      const address = data?.address;
      let shortAddress = "";
      if (address?.city) shortAddress += address?.city + " , "; // City
      if (address?.neighbourhood)
        shortAddress += address?.neighbourhood + " , "; // Neighbourhood
      if (address?.road) shortAddress += address?.road; // Street name

      setAddress(shortAddress);
    }
  }, [data]);

  const RecenterAutomatically = () => {
    const map = useMap();
    setMap(map);
    useEffect(() => {
      map.on("moveend", async function () {
        const center = map.getCenter();
        setLocation({
          lat: center.lat,
          lon: center.lng,
        });
      });
    }, []);
    return null;
  };

  useEffect(() => {
    if (!map) return;

    // Store the button reference
    const button = L.easyButton(
      `<div style="margin-top: 15px;">
      ${
        loading
          ? `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-reload" width="20" height="20" viewBox="0 0 24 24" stroke-width="1.5" stroke="#00abfb" fill="none" stroke-linecap="round" stroke-linejoin="round">
          <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
          <path d="M19.933 13.041a8 8 0 1 1 -9.925 -8.788c3.899 -1 7.935 1.007 9.425 4.747" />
          <path d="M20 4v5h-5" />
        </svg>`
          : `<svg
            xmlns="http://www.w3.org/2000/svg"
            class="icon icon-tabler icon-tabler-current-location"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="black"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
            <path d="M12 12m-8 0a8 8 0 1 0 16 0a8 8 0 1 0 -16 0" />
            <path d="M12 2l0 2" />
            <path d="M12 20l0 2" />
            <path d="M20 12l2 0" />
            <path d="M2 12l2 0" />
          </svg>`
      }
      <div/>`,
      () => {
        setLoading(true);
        map.locate().on("locationfound", function (e) {
          setLocation({
            lat: e.latlng.lat,
            lon: e.latlng.lng,
          });
          setLoading(false);
          map.setView(e.latlng, map.getZoom());
          // map.flyTo(e.latlng, map.getZoom());
        });
      }
    ).addTo(map);

    // Clean up on component unmount
    return () => {
      button.remove();
    };
  }, [map]);

  // Update the button content when the loading state changes
  useEffect(() => {
    if (!map) return;

    const buttonContent = `<div style="margin-top: 4px;">
    ${
      loading
        ? `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-reload" width="20" height="20" viewBox="0 0 24 24" stroke-width="1.5" stroke="#00abfb" fill="none" stroke-linecap="round" stroke-linejoin="round">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M19.933 13.041a8 8 0 1 1 -9.925 -8.788c3.899 -1 7.935 1.007 9.425 4.747" />
        <path d="M20 4v5h-5" />
      </svg>`
        : `<svg
          xmlns="http://www.w3.org/2000/svg"
          class="icon icon-tabler icon-tabler-current-location"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="black"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
          <path d="M12 12m-8 0a8 8 0 1 0 16 0a8 8 0 1 0 -16 0" />
          <path d="M12 2l0 2" />
          <path d="M12 20l0 2" />
          <path d="M20 12l2 0" />
          <path d="M2 12l2 0" />
        </svg>`
    }
    <div/>`;

    const buttonElement = document.querySelector(".easy-button-button");
    if (buttonElement) {
      buttonElement.innerHTML = buttonContent;
    }
  }, [loading, map]);

  useEffect(() => {
    if (!map) return;
    if (center) map.setView([center.lat || 0, center.lon || 0], map.getZoom());
    // map.flyTo({
    //   lat: center.lat || 0,
    //   lng: center.lon || 0,
    // });
  }, [center?.lat, center?.lon, map]);

  const Search = () => {
    const map = useMap();

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    useEffect(() => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const searchControl = new GeoSearchControl({
        provider: new OpenStreetMapProvider({
          params: {
            countrycodes: "IR",
            "accept-language": "fa",
          },
        }),
        style: "bar",
        updateMap: false,
        autoClose: true,
        getZoom: map.getZoom(),
        searchLabel: "جستجو بر اساس شهر و یا محله...",
        resultFormat: (result: any) => filterByLocationType(result),
      });

      // Custom filter function to limit the results to province, city, and neighborhood
      function filterByLocationType(result: any) {
        const addressParts = result?.result?.label
          .split(",")
          .map((part: string) => part.trim());
        let shortAddress = "";

        if (addressParts[0]) shortAddress += addressParts[0]; // City
        if (addressParts[1]) shortAddress += " , " + addressParts[1]; // Road

        return shortAddress;

        return null;
      }

      // Apply custom styles using JavaScript after the control is added
      setTimeout(() => {
        const searchInput = document.querySelector(
          ".leaflet-control-geosearch input"
        ) as HTMLInputElement;

        if (searchInput) {
          searchInput.style.direction = "rtl";
          searchInput.style.fontFamily = "IRANSans, sans-serif";
          searchInput.style.fontSize = "12px";
          searchInput.style.paddingRight = "10px";
        }
      });

      map.addControl(searchControl);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      map.on("geosearch/showlocation", function (result: any) {
        const { x, y } = result.location;
        const customZoomLevel = 17;
        map.setView([y, x], customZoomLevel);
      });
      return () => map.removeControl(searchControl);
    }, []);

    return null; // don't want anything to show up from this comp
  };

  return (
    <>
      <div className={Styled["map-container"]}>
        <div className={Styled["map-container__marker"]}></div>
        <MapContainer
          center={[latLng?.lat || 0, latLng?.lon || 0]}
          zoom={17}
          scrollWheelZoom={true}
          style={{
            width: "100%",
            height: "300px",
            direction: "ltr",
          }}
        >
          <Search />
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <RecenterAutomatically />
        </MapContainer>
      </div>
    </>
  );
}

export default MapAddress;
